import {
  FLOW_CONDITIONAL_ELSE_CONDITION_ID,
  type FlowConditionalConfig,
  FlowConditionalType,
  flowConditionalConfigSchema,
} from 'flow-schema';

import { ConditionalFormFields } from './FormFields';
import { ConditionalNodeOutputContent } from './OutputContent';
import { getNewCondition } from './constants';
import { conditionalBlockDocumentationMarkdown } from './documentation';
import { getNodeOutputHandle } from './getNodeOutputHandle';
import { type BlockConfigProps } from '../../types';

export const conditionalConfig: BlockConfigProps<FlowConditionalConfig> = {
  nodeHandles: (config) => {
    return [
      { type: 'target' },
      ...config.conditions.map(getNodeOutputHandle),
      {
        type: 'source',
        id: FLOW_CONDITIONAL_ELSE_CONDITION_ID,
        handleName: 'Else',
      },
    ];
  },
  defaultLabelPrefix: 'multiConditional',
  defaultConfig: {
    conditionalType: FlowConditionalType.MatchFirst,
    conditions: [getNewCondition()],
  },
  configFields: {
    schema: flowConditionalConfigSchema,
    FormFields: ConditionalFormFields,
  },
  documentationMarkdown: conditionalBlockDocumentationMarkdown,
  OutputContentComponent: ConditionalNodeOutputContent,
};
